import React from "react";
import Modal from "components/modal";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import Image from "components/image";
import MediaQuery from "components/media-query";
import { SCREEN_SIZES } from "utils/constants";
import clsx from "clsx";

const OptionImage = ({ image, tag, isMobile = false }) => (
	<div className="relative">
		<Image image={image} className="w-full z-10" />
		{tag &&
			<span
				className={clsx("font-bold bg-beige absolute py-1 z-10",
					isMobile ? "text-sm top-3 left-3 px-2" : "text-xl top-5 left-5 px-3")}>
				{tag}
			</span>
		}
	</div>
);

const OptionInfoModal = ({ data, isOpen, toggle }) => (
	<Modal
		isOpen={isOpen}
		close={toggle}
		className="text-center w-4/5 max-w-[700px] relative max-h-[95%]"
		hideHeader
	>
		<div className="px-4 md:px-8 pb-4 md:pb-8 md:max-h-[855px]">
			<div className="sticky top-0 bg-white w-full pt-2 md:pt-4">
				<div className="flex">
					<h4 className="text-start md:text-[28px] font-medium pr-8 w-fit content-center">{data.title}</h4>
					<button className="ml-auto p-2 md:p-3 bg-cream" onClick={toggle}>
						<Close className="size-4 md:size-5" />
					</button>
				</div>
				<hr className="mb-3 mt-1 md:mt-2 md:mb-4" />
			</div>
			<div className="flex flex-col gap-6">
				{data.optionsInfo.map((option, index) => (
					<div key={index} className="flex flex-col items-start gap-2">
						<h5 className="font-bold font-base">{option.title}</h5>
						{option.description && <span className="text-start text-sm md:text-base">{option.description}</span>}
					</div>
				))}
			</div>
			<MediaQuery minWidth={SCREEN_SIZES.md}>
				<div className="flex flex-col md:flex-row mt-6">
					{data.optionsInfo.map((option, index) =>
						option.image && <OptionImage key={index} image={option.image} tag={option.tag} />
					)}
				</div>
			</MediaQuery>
			<MediaQuery maxWidth={SCREEN_SIZES.md}>
				<div className="flex flex-col md:flex-row mt-6">
					{data.optionsInfo.map((option, index) =>
						option.mobileImage && <OptionImage key={index} image={option.mobileImage} tag={option.tag} isMobile />
					)}
				</div>
			</MediaQuery>
		</div>
	</Modal>
);

export default OptionInfoModal;
